import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import YearGroupDetails from "./routes/YearGroupDetails";
export default store => ({
  path: "yearGroup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([import("./components")]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [YearGroupDetails(store)],
});
